"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const react_1 = tslib_1.__importDefault(require("react"));
const reusables_1 = require("../../../comps/reusables");
const routeContainers_1 = require("../../../comps/routeContainers");
const graphql_1 = require("../../../graphql");
const Nav_1 = require("./Nav");
const routes_1 = require("./routes");
const ResendInvite_1 = require("./routes/ResendInvite");
const UserInvite_1 = require("./routes/UserInvite");
const OsmosysResourcePage_1 = require("../../../comps/reusables/OsmosysResourcePage");
const WorkspaceDashboard_1 = require("./routes/WorkspaceDashboard");
const use_react_router_1 = tslib_1.__importDefault(require("use-react-router"));
const hooks_1 = require("../../../hooks");
const Home_1 = require("./routes/Home");
const AdminSettings_1 = require("./routes/AdminSettings");
const NotFoundPage_1 = require("../../../comps/NotFoundPage");
const react_router_dom_1 = require("react-router-dom");
exports.WorkspaceDetail = ({ basePath }) => {
    const { history, match } = use_react_router_1.default();
    const { currentWorkspace } = hooks_1.useOsmosysContext();
    const id = match.params.id || currentWorkspace.id;
    return (react_1.default.createElement(reusables_1.OsmosysResourcePage, { query: graphql_1.workspace, paths: {
            item: 'workspace',
        }, variables: {
            id,
        }, getNav: data => {
            return react_1.default.createElement(Nav_1.Nav, { basePath: basePath, workspace: data.workspace });
        }, getTitle: data => (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faBuilding, className: "mr-3" }),
            data.workspace.name)), getSubTitle: () => react_1.default.createElement(react_1.default.Fragment, null, "Workspace") },
        react_1.default.createElement(OsmosysResourcePage_1.OsmosysResourcePageInner, { container: !history.location.pathname.includes('dashboards') }, data => (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_router_dom_1.Switch, null,
                react_1.default.createElement(routeContainers_1.OsmosysRoute, { exact: true, path: basePath, component: Home_1.Home, componentProps: {
                        workspace: data.workspace,
                    }, overflow: "show" }),
                react_1.default.createElement(routeContainers_1.OsmosysRoute, { exact: true, path: `${basePath}/invite-user`, component: UserInvite_1.UserInvite, componentProps: {
                        workspace: data.workspace,
                    }, access: "workspaceAdmin", overflow: "show" }),
                react_1.default.createElement(routeContainers_1.OsmosysRoute, { exact: true, path: `${basePath}/resend-invite`, component: ResendInvite_1.ResendInvite, componentProps: {
                        workspace: data.workspace,
                    }, overflow: "show", access: "workspaceAdmin" }),
                react_1.default.createElement(routeContainers_1.OsmosysRoute, { exact: true, path: `${basePath}/admin`, component: AdminSettings_1.AdminSettings, componentProps: {
                        workspace: data.workspace,
                    }, overflow: "show", access: "workspaceAdmin" }),
                react_1.default.createElement(routeContainers_1.OsmosysRoute, { exact: true, path: `${basePath}/settings`, component: routes_1.Settings, componentProps: {
                        workspace: data.workspace,
                    }, overflow: "show", access: "workspaceAdmin" }),
                react_1.default.createElement(routeContainers_1.OsmosysRoute, { exact: true, path: `${basePath}/users`, component: routes_1.Users, componentProps: {
                        workspace: data.workspace,
                    }, overflow: "show", access: "workspaceAdmin" }),
                react_1.default.createElement(routeContainers_1.OsmosysRoute, { exact: true, path: `${basePath}/dashboards/:activeUrlIndex?`, component: WorkspaceDashboard_1.WorkspaceDashboard, componentProps: {
                        workspace: data.workspace,
                    }, overflow: "show", access: "workspaceAdmin" }),
                react_1.default.createElement(routeContainers_1.OsmosysRoute, { exact: true, path: `${basePath}/dashboards/:activeUrlIndex?`, component: WorkspaceDashboard_1.WorkspaceDashboard, componentProps: {
                        workspace: data.workspace,
                    }, overflow: "show", access: "workspaceAdmin" }),
                react_1.default.createElement(react_router_dom_1.Route, { component: () => react_1.default.createElement(NotFoundPage_1.NotFoundPage, null) })))))));
};
exports.default = exports.WorkspaceDetail;
//# sourceMappingURL=index.js.map